import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import logo from "../images/catalyst/logo.png";
import day1 from "../images/catalyst/catalyst-day-1.svg";
import day2 from "../images/catalyst/catalyst-day-2.svg";

const Catalyst = () => {
  const styles = {
    blackbg: {
      backgroundColor: "#121212",
    },
    blueText: {
      color: "#037ef3",
    },
    hidden: {
      visibility: "hidden",
    },
  };

  const logoRef = useRef(null);
  const titleRef = useRef(null);

  const spinLogo = (e) => {
    gsap.fromTo(
      "#catalyst-logo",
      {
        rotate: "0",
      },
      {
        rotate: "-360",
        duration: 2,
        ease: "expo.inOut",
      }
    );

    gsap.fromTo(
      "#catalyst-logo",
      1,
      {
        scale: 1,
      },
      {
        scale: 1.1,
        yoyo: true,
        repeat: 1,
        duration: 1,
        ease: "expo.in",
      },
      "<"
    );
  };

  useEffect(() => {
    gsap.set(".sc-title", {
      autoAlpha: 0,
      y: 60,
    });

    gsap.set(".agenda-image", {
      autoAlpha: 0,
      y: 60,
    });

    let t1 = gsap.timeline({ repeat: 0 });

    t1.from(logoRef.current, {
      rotate: 100,
      ease: "expo.inOut",
      autoAlpha: 0,
      scale: 0.5,
      y: 100,
      duration: 2,
    });

    t1.from(
      titleRef.current,
      {
        ease: "expo.inOut",
        autoAlpha: 0,
        y: 80,
        duration: 2,
      },
      "<"
    );

    t1.to(
      ".sc-title",
      {
        y: 0,
        ease: "expo.out",
        scale: 1,
        autoAlpha: 1,
        duration: 1,
        delay: 1,
      },
      "<"
    );

    t1.to(
      ".agenda-image",
      {
        y: 0,
        ease: "expo.out",
        autoAlpha: 1,
        duration: 1,
        delay: 0.3,
      },
      "<"
    );
  }, []);

  return (
    <div className="w-full min-h-screen text-white pb-8" style={styles.blackbg}>
      <div className="w-full flex flex-col justify-center items-center pt-10">
        <img
          src={logo}
          alt="catalyst-logo"
          ref={logoRef}
          id="catalyst-logo"
          className="w-20 el"
          style={styles.hidden}
          onClick={(e) => spinLogo(e)}
        />
        <div
          className="mt-4 text-5xl"
          ref={titleRef}
          style={{ ...styles.hidden, fontFamily: "catalyst" }}
        >
          CATALYST 2021
        </div>

        <div
          className="mt-8 text-3xl font-thin sc-title text-center"
          style={{ color: "#037ef3" }}
        >
          Agenda - Day 1
        </div>

        <div className="my-2 text-white opacity-50 sc-title">
          All times are in GMT+5:30
        </div>

        <div className="w-full max-w-2xl m-auto mt-4 px-4 agenda-image">
          <img src={day1} />
        </div>

        <div
          className="mt-32 text-3xl font-thin sc-title text-center"
          style={{ color: "#037ef3" }}
        >
          Agenda - Day 2
        </div>

        <div className="my-2 text-white opacity-50 sc-title">
          All times are in GMT+5:30
        </div>

        <div className="w-full max-w-2xl m-auto mt-4 px-4 agenda-image mb-12">
          <img src={day2} />
        </div>
      </div>
    </div>
  );
};

export default Catalyst;
